import React from 'react';

import { AccountGM, AccountMathPid } from '../account';
import AccountGB from '../global/AccountGB';
import EntryCheck from '../provider/EntryCheck';

function Account() {
  return (
    <EntryCheck
      GM_APP={<AccountGM />}
      GM={<AccountGM />}
      CP={<AccountGM />}
      MATH_PID={<AccountMathPid />}
      GLOBAL01={<AccountGB />}
    />
  );
}

export default Account;